'use strict';

/**
 * @name core
 */

exports.HBNBVersion = require('./hbnb_version.js');
exports.supportApis = require('./support_apis.js');
exports.OSVersion = require('./os_version.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/core/index.js
// module id = Fepm
// module chunks = 0